module.exports = __webpack_public_path__ + "static/media/sky.8e12278d.png";